import React from 'react';
import PropTypes from 'prop-types';
import { filter } from 'lodash';
import Progress from 'reactstrap/lib/Progress';
import FontIcon from 'components/FontIcon';
import ExpandableList from 'components/ExpandableList';
import classes from './ImportProduct.module.scss';

const showTotalProgress = (total, label, progressValue) => (
  <div className={classes.colorContainer}>
    <div className={classes.circularNumberAndLabel}>
      <div className={`${classes.circle} ${classes.blueCircle}`}>
        <span className={classes.number}>{total}</span>
      </div>
      <div className={classes.numberLabel}>
        {label}
      </div>
    </div>
    <div className={classes.progressBar}>
      <div className={classes.numberLabel}>
        Current progress
      </div>
      <Progress
        striped
        color='info'
        value={progressValue}
      />
    </div>
  </div>
);

const showStats = (createdTotal, createdLabel, failedTotal, failedLabel) => (
  <div className={classes.colorContainer}>
    <div className={classes.circularNumberAndLabel}>
      <div className={`${classes.circle} ${classes.greenCircle}`}>
        <span className={classes.number}>{createdTotal}</span>
      </div>
      <div className={classes.numberLabel}>
        {createdLabel}
      </div>
    </div>
    <div className={classes.circularNumberAndLabel}>
      <div className={`${classes.circle} ${classes.redCircle}`}>
        <span className={classes.number}>{failedTotal}</span>
      </div>
      <div className={classes.numberLabel}>
        {failedLabel}
      </div>
    </div>
  </div>
);

const prepareErrorItem = (product) => ({
  title: product.Title,
  body: JSON.stringify(product.error),
});

const renderErrorPanel = (renderButton, toggleErrorPanel, products) => (
  <div>
    {renderButton('ButtonB', 'Collapse the list of errors', toggleErrorPanel)}
    <div className={classes.innerColorContainer}>
      <ExpandableList
        type='ExpandableListItemA'
        renderStructuredData={false}
        items={filter(products, (prod) => prod.processed && !prod.success).map(prepareErrorItem)}
      />
    </div>
  </div>
);

const showCompletedAction = (
  cancelProcess,
  renderButton,
  failedProducts,
  showErrorPanel,
  toggleErrorPanel,
  products,
) => (
  <div className={classes.colorContainer}>
    <div className={classes.title}>
      Process completed!
    </div>
    {
        failedProducts > 0 &&
        !showErrorPanel &&
        renderButton('ButtonB', 'Click here to see the list of errors', toggleErrorPanel)
      }
    {showErrorPanel && renderErrorPanel(renderButton, toggleErrorPanel, products)}
    {renderButton('ButtonA', 'Upload new file', () => document.location.reload())}
  </div>
);

const ImportProductStep3 = (props) => {
  const {
    products,
    failedProducts,
    createdProducts,
    completed,
    cancelProcess,
    renderButton,
    showErrorPanel,
    toggleErrorPanel,
  } = props;

  return (
    <div className={classes.container}>
      <div className={classes.contentContainer}>
        <div className={classes.statsWrapper}>
          {
            showTotalProgress(
              products.length,
              'Total number of products',
              Math.floor((filter(products, (prod) => prod.processed).length / products.length) * 100),
            )
          }
          {
            showStats(
              createdProducts,
              'Created Products',
              failedProducts,
              'Failed Products',
            )
          }
        </div>
        {!completed && <FontIcon className={classes.spinnerIcon} icon='far fa-spinner fa-spin' />}
        {
          completed &&
          showCompletedAction(cancelProcess, renderButton, failedProducts, showErrorPanel, toggleErrorPanel, products)
        }
      </div>
    </div>
  );
};

ImportProductStep3.propTypes = {
  products: PropTypes.array,
  failedProducts: PropTypes.number,
  createdProducts: PropTypes.number,
  cancelProcess: PropTypes.func,
  completed: PropTypes.bool,
  renderButton: PropTypes.func,
  showErrorPanel: PropTypes.bool,
  toggleErrorPanel: PropTypes.func,
};

export default ImportProductStep3;
